const MULTI_SELECT = 'MULTI_SELECT'
const MULTIPLE_CHOICE = 'MULTIPLE_CHOICE'
const NUMBER = 'NUMBER'
const FREE_TEXT = 'FREE_TEXT'
const DATE = "DATE"

export default {
  MULTI_SELECT,
  MULTIPLE_CHOICE,
  NUMBER,
  FREE_TEXT,
  DATE,
}
